import { ApiError } from '@/services/api/ApiError'

/**
 * A request failed while the device was offline, so it never left the device.
 * TanStack's `onlineManager` starts out online and only learns otherwise from
 * an `offline` event, so on a cold start without a connection the retryer
 * doesn't pause: replayable mutations retry this error with backoff instead
 * (`lib/mutationReplay.ts`), which keeps a queued write queued until the
 * connection is back.
 */
export class OfflineError extends ApiError {
  constructor() {
    super('Network error. Please check your connection.', 0)
    this.name = 'OfflineError'
  }
}
